import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import FullScreenLoader from "./FullScreenLoader";
import {
	clearSessionSwitchFlag,
	isSessionSwitchInProgress,
	SESSION_SWITCH_FLAG_KEY,
} from "./sessionSwitchUtils";

const HIDE_DELAY_AFTER_AUTH_MS = 800;
const FALLBACK_TIMEOUT_MS = 7000;

const SessionSwitchOverlay = () => {
	const isAuthenticated = useSelector(
		(state) => state.auth && state.auth.isAuthenticated
	);
	// Vérifier immédiatement au montage pour éviter tout délai
	const [visible, setVisible] = useState(() => {
		// Vérification synchrone immédiate
		if (typeof window !== "undefined" && window.sessionStorage) {
			try {
				const flag = window.sessionStorage.getItem(SESSION_SWITCH_FLAG_KEY);
				return flag === "true";
			} catch (e) {
				return false;
			}
		}
		return false;
	});

	useEffect(() => {
		// Ensure we do not keep a stale overlay if nothing updates it.
		if (!visible) {
			return undefined;
		}

		const fallbackTimer = setTimeout(() => {
			clearSessionSwitchFlag();
			setVisible(false);
		}, FALLBACK_TIMEOUT_MS);

		return () => clearTimeout(fallbackTimer);
	}, [visible]);

	useEffect(() => {
		if (!visible || !isAuthenticated) {
			return undefined;
		}

		const hideTimer = setTimeout(() => {
			clearSessionSwitchFlag();
			setVisible(false);
		}, HIDE_DELAY_AFTER_AUTH_MS);

		return () => clearTimeout(hideTimer);
	}, [visible, isAuthenticated]);

	// Vérifier périodiquement le flag pour une réactivité immédiate
	useEffect(() => {
		if (!visible) {
			return undefined;
		}

		const checkInterval = setInterval(() => {
			const inProgress = isSessionSwitchInProgress();
			if (!inProgress && visible) {
				setVisible(false);
			}
		}, 100);

		return () => clearInterval(checkInterval);
	}, [visible]);

	useEffect(() => {
		// In rare cases (like navigating back), sessionStorage can still contain the flag.
		const handleStorageChange = (event) => {
			if (
				event.storageArea === sessionStorage &&
				event.key === SESSION_SWITCH_FLAG_KEY
			) {
				setVisible(event.newValue === "true");
			}
		};

		window.addEventListener("storage", handleStorageChange);

		return () => window.removeEventListener("storage", handleStorageChange);
	}, []);

	return (
		<FullScreenLoader
			open={visible}
			message="Changement de compte en cours..."
		/>
	);
};

export default SessionSwitchOverlay;


